import { NBSP } from '../../../../../../../../constants/symbols';
import { createService } from '../../createService';

export const WithoutBetService = createService({
  title: 'Без ставки',
  subTitle: 'Нет продвижения',
  description: `Поднимите ставку до${NBSP}Топа и${NBSP}получите больше просмотров и${NBSP}звонков`,
  dataName: 'WithoutBetService',
  bgColor: 'white',
  icon: null,
});
